// extracted by mini-css-extract-plugin
export default {"search":"SearchBox_search__SZ0pm"};